import * as Long from "long";
import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { utilShop } from "../../../utils/utilShop";
import { Badge } from "../../generic/badge/Badge";
import { IdBadgePosition } from "../../generic/badge/IdBadgePosition";
import { ButtonInfoSmall } from "../../generic/common/ButtonInfoSmall";
import { componentWithProps } from "../../generic/componentWithProps";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { DynamicTooltip } from "../../tooltip";
import { OfferBadgePurchasePoints } from "./OfferBadgePurchasePoints";
import { OfferBadgeWebBonus } from "./OfferBadgeWebBonus";
import { OfferButtonBuy } from "./OfferButtonBuy";
import { OfferGoldRewardTooltip } from "./OfferGoldRewardTooltip";
export var OfferHC = function (_a) {
    var offer = _a.offer, _b = _a.disableBuyButton, disableBuyButton = _b === void 0 ? false : _b, offerIndex = _a.offerIndex;
    var onBuyClick = offer.onBuyClick, webBonusGold = offer.webBonusGold, baseGoldValue = offer.baseGoldValue, shopPackage = offer.shopPackage, purchasePoints = offer.purchasePoints, primeTimeBonus = offer.primeTimeBonus, subscriptionBonus = offer.subscriptionBonus;
    var hasSubscriptionBuff = subscriptionBonus && subscriptionBonus.gt(Long.ZERO);
    var headerFontStyle = hasSubscriptionBuff ? IdStyles.HeadlineAccent : IdStyles.HeadlineOne;
    var baseGoldWithSubscriptionBonus = Long.fromValue(baseGoldValue)
        .add(subscriptionBonus || Long.ZERO)
        .add(primeTimeBonus || Long.ZERO)
        .add(webBonusGold || Long.ZERO);
    var tooltipComponent = componentWithProps({
        ComponentType: OfferGoldRewardTooltip,
        offer: offer,
    });
    var tooltipAnchor = utilShop.getHCOfferTooltipAnchor(offerIndex || 0);
    return (React.createElement(DynamicTooltip, { component: tooltipComponent, anchor: tooltipAnchor, visibleOnClick: true, safe: true },
        React.createElement("div", { className: IdStyles.OfferShittyPackageHeader + " offer-hc__container" },
            React.createElement("div", { className: "offer-hc__main-content" },
                React.createElement(Badge, { position: IdBadgePosition.TopLeft },
                    React.createElement(ButtonInfoSmall, null,
                        React.createElement(Icon, { icon: IdIcon.InfoIcn, styleId: IdStyles.IconSmall }))),
                React.createElement(OfferBadgeWebBonus, { bonusGold: webBonusGold, className: "offer-hc__web-bonus", idLoca: IdLoca.goldSum_includeWebBonus }),
                React.createElement(OfferBadgePurchasePoints, { purchasePoints: purchasePoints, className: "offer-hc__purchase-points" }),
                React.createElement(Icon, { icon: IdIcon.GoldIcn, styleId: IdStyles.IconMedium }),
                React.createElement("div", { className: "flex flex--aligned flex--stacked" },
                    React.createElement(NumberFormat, { className: headerFontStyle, amount: baseGoldWithSubscriptionBonus }))),
            !disableBuyButton && (React.createElement("div", { className: "offer-hc__buy-btn" },
                React.createElement(OfferButtonBuy, { shopPackage: shopPackage, onClick: function () { return onBuyClick(offer); } }))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/OfferHC.tsx
// module id = 962
// module chunks = 3